import { combineReducers } from 'redux';
import { Backgrounds, STATE_KEY as LOAD_BACKGROUND_STATE_KEY } from './backgrounds';


const backgrounds = combineReducers({
  [LOAD_BACKGROUND_STATE_KEY]: Backgrounds,
});

export default backgrounds;



// WEBPACK FOOTER //
// ./src/redux/reducers/backgrounds/index.js